export default "__VITE_ASSET__B0E3iNnH__"